import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EAnalyticsActionConstant, EAnalyticsGoal, EAnalyticsItemTypeConstant } from "../../../../../../../constants";
import { getCommonAnalyticsData, withPaymentAnalyticsField } from "../../../../../../../utils/ym.helpers";
import { findFirst } from "../../../../../../../utils/arrays";
import { EResult } from "./types";
import { getPaymentOptionTypeFromId } from "../../../PaymentSelection/components/PaymentMethodSection/Button/logic/utils";
export var getOnScreenAnalyticsHandler = function getOnScreenAnalyticsHandler(_ref) {
  var getAccountType = _ref.getAccountType,
    getWindow = _ref.getWindow,
    ymReachGoal = _ref.ymReachGoal,
    getState = _ref.getState,
    ymPushParams = _ref.ymPushParams;
  return function (props) {
    var _getState;
    var _ref2 = (_getState = getState()) !== null && _getState !== void 0 ? _getState : {},
      sumInput = _ref2.sumInput,
      _ref2$selectedPayment = _ref2.selectedPaymentId,
      selectedPaymentId = _ref2$selectedPayment === void 0 ? '' : _ref2$selectedPayment;
    var payment_method = getPaymentOptionTypeFromId(selectedPaymentId);
    var isSuccess = props.result === EResult.Success;
    var isError = props.result === EResult.Error;
    var order_price = sumInput === null || sumInput === void 0 ? void 0 : sumInput.value;
    ymPushParams(withPaymentAnalyticsField(_objectSpread(_objectSpread({}, getCommonAnalyticsData(getWindow(), getAccountType())), {}, {
      action: EAnalyticsActionConstant.View,
      item_type: EAnalyticsItemTypeConstant.Page,
      payment_status: findFirst([isSuccess && 'success', isError && 'fail']),
      order_price: order_price,
      payment_method: payment_method
    })));
    if (!isSuccess) return;
    ymReachGoal(EAnalyticsGoal.Payment, withPaymentAnalyticsField({
      order_price: order_price,
      currency: 'RUB',
      payment_method: payment_method
    }));
  };
};